<template>
  <div class="main-wrapper">
    <div class="main-page">
      <keep-alive>
        <component :is="currentPage" :data="param"></component>
      </keep-alive>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick" tab-position="bottom" stretch class="demo-tabs">
      <el-tab-pane name="first" lazy>
        <template #label>
          <div class="tab-each">
            <i class="el-icon-house"></i>首页
          </div>
        </template>
      </el-tab-pane>
      <el-tab-pane name="second" lazy>
        <template #label>
          <div class="tab-each">
            <i class="el-icon-user"></i>我的
          </div>
        </template>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import  homeDetailPage from './HomeDetailPage'   
import  myPage from './MyPage'   
import  allTeachTypePage from './AllTeachTypePage'   
import  searchPage from './SearchPage'  

export default {
  name: 'HomePage',
  props: ['id'],
  components: {
    homeDetailPage,
    myPage,
    allTeachTypePage,
    searchPage
  },
  data() {
    return {
      activeName: 'first',
      currentTab: 0,
      tabList: [],
      merchantId: '',
      param: {}
    }
  },
  created() {
    let active = localStorage.getItem('activeName') || 'first';
    if(active === 'first') {
       this.currentTab = 0;
    } else {
      this.currentTab = 1;
    }
    this.activeName = active;
    this.merchantId = this.id;
    if(this.$route.query) {
      this.param = this.$route.query;
    }
    this.param.merchantId = this.id;
    let pageType = this.$route.query.value;
    if(pageType !== undefined &&  pageType !== null) {
      this.tabList = [{
        label: '首页',
        component: pageType
      }, {
        label: '我的',
        component: 'myPage'
      }];
    } else {
      this.tabList = [{
        label: '首页',
        component: 'homeDetailPage'
      }, {
        label: '我的',
        component: 'myPage'
      }];
    }
  },
  methods: {
    handleClick(tab) {
      if(tab.paneName === 'first') {
        this.currentTab = 0;
        this.activeName = 'first';
        localStorage.setItem('activeName', 'first');
      } else {
        this.currentTab = 1;
        this.activeName = 'second';
        localStorage.setItem('activeName', 'second');
      }
    }
  },
  computed: {
    currentPage() {
      return this.tabList[this.currentTab].component;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main-wrapper {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

.demo-tabs {
  width: 100%;
  height: 50px;
  border-top: 1px solid #f5f5f5;
}

.main-page {
  flex: 1;
}

::v-deep .el-tabs__header {
  margin: 0;
}

::v-deep .el-tabs__item {
  color: #333;
  padding: 0;
  font-size: 14px;
}

::v-deep .el-tabs__item.is-active {
  color: #0095D9 !important;
}

::v-deep .el-tabs__active-bar {
  height: 0;
}

::v-deep .el-tabs__nav-wrap::after {
  height: 0;
}

.tab-each {
  display: flex;
  flex-direction: column;
  line-height: 25px;
  font-size: 12px;
}

</style>